import { render, staticRenderFns } from "./null.vue?vue&type=template&id=3627917c&scoped=true"
import script from "./null.vue?vue&type=script&lang=js"
export * from "./null.vue?vue&type=script&lang=js"
import style0 from "./null.vue?vue&type=style&index=0&id=3627917c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627917c",
  null
  
)

export default component.exports